// filepath: src/pages/profile/profile.constants.ts

export type ProfileTabKey =
  | "ABOUT"
  | "ADDRESS"
  | "COMMUNICATION_DETAILS"
  | "PROFESSIONAL_BACKGROUND"
  | "MARRIAGE_REGISTRATION"
  | "FAMILY";

export const PROFILE_TABS: ProfileTabKey[] = [
  "ABOUT",
  "ADDRESS",
  "COMMUNICATION_DETAILS",
  "PROFESSIONAL_BACKGROUND",
  "MARRIAGE_REGISTRATION",
  "FAMILY",
];

export const HIDE_EDIT_BUTTON_TABS: ProfileTabKey[] = ["FAMILY", "MARRIAGE_REGISTRATION"];

export const isEditHiddenForTab = (tab: ProfileTabKey) => HIDE_EDIT_BUTTON_TABS.includes(tab);
